import React from 'react'

function Tbody({ children }) {
    return (
        <tbody
            className='divide-y divide-gray-100 text-gray-900 font-medium text-sm'
        >
            {children}
        </tbody>
    )
}

export default Tbody